import Vue from 'vue'
import { PUBLIC_PATH } from '@/enviroment/global'
import VueRouter from 'vue-router'
import middleware from '@/router/middleware'
export const ABOUT_VIEW = 'about'
export const LOGIN_VIEW = 'login'
export const VIEWER_VIEW = 'viewer'
export const DESIGN_VIEW = 'plk_design'
export const CONNECTIONS_VIEW = 'plk_connections'
export const CSS_VIEW = 'plk_styles'
export const JS_VIEW = 'plk_javascript'

Vue.use(VueRouter)

const routes = [
  {
    path: '/plaka_design',
    name: DESIGN_VIEW,
    component: () => import(/* webpackChunkName: "design" */ '../views/Design/Design.vue'),
    meta: {
      middleware
    }
  },
  {
    path: '/plk_javascript',
    name: JS_VIEW,
    component: () => import(/* webpackChunkName: "javascript" */ '../views/Design/Javascript.vue')
  },
  {
    path: '/plaka_styles',
    name: CSS_VIEW,
    component: () => import(/* webpackChunkName: "styles" */ '../views/Design/Styles.vue')
  },
  {
    path: '/plaka_connections',
    name: CONNECTIONS_VIEW,
    component: () => import(/* webpackChunkName: "connections" */ '../views/Design/Connections.vue')
  },
  {
    path: '/login',
    name: LOGIN_VIEW,
    component: () => import(/* webpackChunkName: "login" */ '../views/Login/Index.vue'),
    meta: {
      middleware
    }
  },
  {
    path: '/plaka',
    name: ABOUT_VIEW,
    component: () => import(/* webpackChunkName: "about" */ '../views/About/Index.vue'),
    meta: {
      middleware
    }
  },
  {
    path: '/:id',
    name: VIEWER_VIEW,
    component: () => window.PLKDesign ? import(/* webpackChunkName: "designviewer" */ '../views/Design/Viewer.vue') : import(/* webpackChunkName: "viewer" */ '../views/Viewer/Index.vue'),
    meta: {
      middleware
    }
  },
  {
    path: '/',
    redirect: '/index',
    meta: {
      middleware
    }
  },
  {
    path: '*',
    name: 'allpage',
    component: () => import(/* webpackChunkName: "about" */ '../views/About/Index.vue'),
    meta: {
      middleware
    }
  }
]

// Creates a `nextMiddleware()` function which not only
// runs the default `next()` callback but also triggers
// the subsequent Middleware function.
function nextFactory (context, middleware, index) {
  const subsequentMiddleware = middleware[index]
  // If no subsequent Middleware exists,
  // the default `next()` callback is returned.
  if (!subsequentMiddleware) return context.next

  return (...parameters) => {
    // Run the default Vue Router `next()` callback first.
    context.next(...parameters)
    // Then run the subsequent Middleware with a new
    // `nextMiddleware()` callback.
    const nextMiddleware = nextFactory(context, middleware, index + 1)
    subsequentMiddleware({ ...context, next: nextMiddleware })
  }
}

const router = new VueRouter({
  mode: 'history',
  base: PUBLIC_PATH,
  routes: routes
})

router.beforeEach((to, from, next) => {
  if (to.meta.middleware) {
    const middleware = Array.isArray(to.meta.middleware)
      ? to.meta.middleware
      : [to.meta.middleware]

    const context = {
      from,
      next,
      router,
      to
    }
    const nextMiddleware = nextFactory(context, middleware, 1)

    return middleware[0]({ ...context, next: nextMiddleware })
  }

  return next()
})

export default router
